import { AuthenticationToken } from "./authentication-token.entity";
import { Serializable } from "./serializable";
import { User } from "./user.entity";
import { UserRole } from "../enums/user-role";

export class LoginResult implements Serializable<LoginResult> {
  private readonly ROLES_ACCESS = [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.DOCTOR];

  public accessToken: AuthenticationToken;
  public refreshToken: AuthenticationToken;
  public user: User;

  /**
   * Transforms received object to LoginResult entity
   * @param input
   * @returns LoginResult entity
   */
  public deserialize(input: any): LoginResult {
    this.accessToken = new AuthenticationToken().deserialize(input.accessToken);
    this.refreshToken = new AuthenticationToken().deserialize(
      input.refreshToken
    );
    this.user = new User().deserialize(input.user);

    return this;
  }

  /**
   * Checks role to access to application
   * @returns access by role
   */
  public canAccessByRole(): boolean {
    return this.ROLES_ACCESS.includes(this.user.role as UserRole);
  }
}
